import { render, staticRenderFns } from "./AccountsPayableFiles.vue?vue&type=template&id=0f159517"
import script from "./AccountsPayableFiles.vue?vue&type=script&lang=js"
export * from "./AccountsPayableFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports